import { SiteType, SiteActionsList  } from "../actions/siteActions";
import { Action } from "../actions/types";

const initialValue: Array<SiteType> = []

export const SiteReducer = (state: SiteType[] =initialValue , action: Action) => {

    switch (action.type) {

        case SiteActionsList.ADD_SITE: {

            return [...state, action.data]
        }

        case SiteActionsList.EDIT_SITE: {
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated
        }

        case SiteActionsList.FETCH_SITE: {

            return action.data
        
        }

        case SiteActionsList.DELETE_SITE: {
            return state.filter(i => i.id !== action.data.id)

        }

        case SiteActionsList.CLEAR_SITE: {
            return initialValue

        }

        default: return state
    }

}